module.exports = __webpack_public_path__ + "assets/voucher_applied.2c58bc77.svg";